export const INSTAGRAM_URL = "https://www.instagram.com/robertodilorenzo_proctologo";

export default function Logo({ light = false }) {
  return (
    <a href="#top" data-testid="logo-home-link" className="flex items-center gap-3 group">
      <svg width="42" height="42" viewBox="0 0 64 64" className="shrink-0">
        <circle cx="32" cy="32" r="30" fill="#161B22" stroke="#D4A359" strokeWidth="1.2" />
        <circle cx="32" cy="32" r="25" fill="none" stroke="#D4A359" strokeWidth="0.6" opacity="0.5" />
        <text x="32" y="40" textAnchor="middle" fontFamily="Playfair Display, Georgia, serif" fontStyle="italic" fontSize="24" fill="#D4A359">RD</text>
      </svg>
      <span className="leading-tight">
        <span className={`font-display block text-lg ${light ? "text-white" : "text-ivory"}`}>
          Dott. Roberto <span className="italic text-gold">Di Lorenzo</span>
        </span>
        <span className={`block text-[10px] uppercase tracking-[0.3em] ${light ? "text-white/70" : "text-silver"}`}>Colonproctologia</span>
      </span>
    </a>
  );
}
